export default __webpack_public_path__ + "static/media/clear_solid_star.39b09519.svg";